"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemOfferQualitySchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.ItemOfferQualitySchema = zod_1.z.object({
    level: zod_1.z.nativeEnum(__1.OfferQualityLevel),
    quality: zod_1.z.number().nonnegative().max(100),
    channelLevel: __1.ShortStringSchema,
    channelQuality: __1.ShortStringSchema,
    channelQualityUrl: __1.LongStringSchema.url().optional(),
});
//# sourceMappingURL=item-quality.js.map